module.exports = __webpack_public_path__ + "static/introduce-bg.82441100.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/introduce-bg.png
// module id = 1024
// module chunks = 2